var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHide = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M10.572 6.204c-4.947.442-8.005 3.213-9.215 5.032a6 6 0 0 0-.25.409.75.75 0 0 0-.043.688q.097.22.234.465c1.132 2.019 4.334 5.118 10.079 5.118q1.084-.002 2.063-.139c4.541-.625 7.37-3.22 8.523-4.953a6 6 0 0 0 .25-.409.75.75 0 0 0 .043-.688 6 6 0 0 0-.234-.466c-1.132-2.018-4.334-5.117-10.079-5.117q-.709 0-1.371.06m10.141 5.79a6.4 6.4 0 0 0-.715-1.01c-1.3-1.525-3.878-3.34-8.055-3.34-5.205 0-8.274 2.821-9.336 4.421l.008.015.055.096c.423.71 1.202 1.638 2.39 2.444 1.458.99 3.532 1.796 6.317 1.796 5.205 0 8.274-2.821 9.336-4.422",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.256 11.996a3.602 3.602 0 1 1-7.203 0 3.602 3.602 0 0 1 7.203 0"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M5.47 3.47a.75.75 0 0 1 1.06 0l16 16a.75.75 0 1 1-1.06 1.06l-16-16a.75.75 0 0 1 0-1.06m-4 0a.75.75 0 0 1 1.06 0l16 16a.75.75 0 1 1-1.06 1.06l-16-16a.75.75 0 0 1 0-1.06",
  clipRule: "evenodd"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M3.47 3.47a.75.75 0 0 1 1.06 0l16 16a.75.75 0 1 1-1.06 1.06l-16-16a.75.75 0 0 1 0-1.06",
  clipRule: "evenodd"
})));
export default SvgHide;